import { ConfigTypeOverride } from '@cp/shared/config';
import { ConfigManager } from './manager';
import { CONTACTS_CONFIG } from './contacts';
import { SOCIAL_MEDIA } from './socialMedia';
import { LEGAL } from './legal';
import { SUPPORT } from './support';

export const createConfigManager = (base: Partial<ConfigTypeOverride>) =>
  new ConfigManager(base, CONTACTS_CONFIG, SOCIAL_MEDIA, LEGAL, SUPPORT);
